import styles from '../select.module.css';

import { ArrowDownIcon } from '../../../helpers/icons';

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../../helpers/components/Icon';

const SelectInput = ({ searchValue, onSearchChange, toggleDropdown, arrowColor, isOpen }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className={styles.searchContainer} onClick={(e) => e.stopPropagation()}>
      <input
        ref={inputRef}
        type="text"
        className={styles.searchInput}
        value={searchValue}
        onChange={onSearchChange}
        placeholder="Поиск..."
      />
      <Icon
        src={ArrowDownIcon}
        width={12}
        height={7}
        aria-hidden="true"
        color={arrowColor}
        className={classNames(styles.arrow, { [styles.open]: isOpen })}
        onClick={toggleDropdown}
      />
    </div>
  );
};

SelectInput.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  arrowColor: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default SelectInput;
